import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import CommonStoryCard from "../../../molecules/common-story-card";
import getStoriesByCollection from "../../../../utils";
import BaseCard from "../../../molecules/base-card"
import "./subscription-collection.m.css";
export const SubscriptionCollection = ({ data }) => {
 
  const subscriptionCollection = data.collection.collection;
  const collections = subscriptionCollection.items.filter(collection => collection.type === "collection");

  return (
    <div styleName="subscription-collection-wrapper">
      {subscriptionCollection.summary && <h2 styleName="summary">{subscriptionCollection.summary}</h2>}
      <div styleName="subscription-collection">
      {collections.slice(0,6).map(item=>{
        return(                   
            <BaseCard collection={item} key={item.id}/>                        
        )
      })}
      </div>
    </div>
  );
};
SubscriptionCollection.propTypes = {
  data: PropTypes.object
};
SubscriptionCollection.storyLimit = 6;
